import { Observable } from 'rxjs';
import { FileUploadItem } from 'src/app/models/files/fileUploadItem';

export abstract class IFileUploadService {
    abstract uploadFiles(filesToUpload: FileUploadItem, id: string): Observable<any>;
    abstract uploadUnassignedDocuments(documents: any): Observable<any>;
}